import { createStore } from "vuex";
import Cookies from "js-cookie";
import axiosApi from "@/axios";

export default createStore({
  state: {
    user: null,
    userEntidade: false,
    toasts: [],
    cidade: "",
    nomeMunicipio: "",
    codigoSiconfi: "",
    isDemo: null,
    hasPendencia: null,
    isAuthLoading: false,
    isMunicipioChangeable: true,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setUserEntidade(state, userEntidade) {
      state.userEntidade = userEntidade;
    },
    addToast(state, toast) {
      state.toasts.push(toast);
    },
    removeToast(state, id) {
      state.toasts = state.toasts.filter((toast) => toast.id !== id);
    },
    setCidade(state, cidade) {
      state.cidade = cidade;
    },
    setNomeMunicipio(state, nomeMunicipio) {
      state.nomeMunicipio = nomeMunicipio;
    },
    setCodigoSiconfi(state, codigoSiconfi) {
      state.codigoSiconfi = codigoSiconfi;
    },
    setIsDemo(state, isDemo) {
      state.isDemo = isDemo;
    },
    setHasPendencia(state, hasPendencia) {
      state.hasPendencia = hasPendencia;
    },
    setAuthLoading(state, isLoading) {
      state.isAuthLoading = isLoading;
    },
    clearAuthData(state) {
      state.user = null;
      state.userEntidade = false;
      state.cidade = "";
      state.nomeMunicipio = "";
      state.codigoSiconfi = "";
      state.isDemo = null;
      state.hasPendencia = null;
      state.isAuthLoading = false;
      state.isMunicipioChangeable = true;
    },
    setIsMunicipioChangeable(state, isMunicipioChangeable) {
      console.log("setIsMunicipioChangeable", isMunicipioChangeable);
      state.isMunicipioChangeable = isMunicipioChangeable;
    },
  },
  actions: {
    async validateToken({ commit }) {
      commit("setAuthLoading", true);
      try {
        const response = await axiosApi.get("/api/validate-token", {
          withCredentials: true,
        });
        
        if (response.data.success) {
          commit("setUser", response.data.data);
          const userEntidadeCookie = Cookies.get("user-entidade");

          if(userEntidadeCookie) {
            const cookieString = userEntidadeCookie.split(`j:`)[1];
            const userEntidadeJson = JSON.parse(cookieString);
            
            commit("setCidade", userEntidadeJson.cidade);
            commit("setNomeMunicipio", `${userEntidadeJson.razao_social.replace("MUNICÍPIO DE ", "")} (${userEntidadeJson.uf})`);
            commit("setIsDemo", userEntidadeJson.demo);
            commit("setHasPendencia", userEntidadeJson.pendencia_financeira)
            commit("setCodigoSiconfi", userEntidadeJson.codigo_siconfi);
          }

          commit("setUserEntidade", !!userEntidadeCookie);
          commit("setAuthLoading", false);
        } else {
          // Handle specific messages for deleted or inactive users
          const message = response.data.message || '';
          
          if (message.includes('User not found') || message.includes('User account is inactive')) {
            // Clear all authentication data for deleted/inactive users
            commit("clearAuthData");
            Cookies.remove("token", { path: '/' });
            Cookies.remove("user-entidade", { path: '/' });
            
            // Throw a specific error for deleted users
            const deletedError = new Error("USER_DELETED");
            deletedError.message = message;
            throw deletedError;
          }
          
          commit("setAuthLoading", false);
          throw new Error("Token validation failed");
        }
      } catch (error) {
        // Check if the error indicates a deleted user
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.message || '';
          
          // Check for user deletion scenarios
          if (status === 404 || 
              status === 401 && message.toLowerCase().includes('user not found') ||
              status === 401 && message.toLowerCase().includes('user deleted') ||
              status === 401 && message.toLowerCase().includes('account deleted')) {
            
            // Clear all authentication data
            commit("clearAuthData");
            
            // Clear cookies
            Cookies.remove("token", { path: '/' });
            Cookies.remove("user-entidade", { path: '/' });
            
            // Throw a specific error for deleted users
            const deletedError = new Error("USER_DELETED");
            deletedError.originalError = error;
            throw deletedError;
          }
        }
        
        // For other errors, set loading to false and throw
        commit("setAuthLoading", false);
        throw error;
      }
    },
    showToast({ commit }, toast) {
      toast.id = Date.now();
      commit("addToast", toast);
      setTimeout(() => {
        commit("removeToast", toast.id);
      }, 7000);
    },
  },
  getters: {
    user: (state) => state.user,
    userEntidade: (state) => state.userEntidade,
    toasts: (state) => state.toasts,
    cidade: (state) => state.cidade,
    nomeMunicipio: (state) => state.nomeMunicipio,
    codigoSiconfi: (state) => state.codigoSiconfi,
    isDemo: (state) => state.isDemo,
    hasPendencia: (state) => state.hasPendencia,
    isAuthLoading: (state) => state.isAuthLoading,
    isMunicipioChangeable: (state) => state.isMunicipioChangeable,
  },
});
